<template>
  <div class="order-examine-popup">
    <el-dialog :title="'单号编辑'"  :close-on-click-modal="false" :visible.sync="visible" width="45%" center>
      <el-form :model="dataForm" ref="dataForm" size="small" label-width="120px">
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="dataForm.customerName" type="text" placeholder="客户名称" show-word-limit :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="客户单号" prop="customerSelfNo">
              <el-input v-model="dataForm.customerSelfNo" type="text" placeholder="客户单号" show-word-limit ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="进仓单号" prop="inWarehouseNo">
              <el-input v-model="dataForm.inWarehouseNo" type="text" placeholder="进仓单号" show-word-limit ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="客服备注" prop="companyRemark">
              <el-input v-model="dataForm.companyRemark" type="text" placeholder="客服备注" show-word-limit ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 认</el-button>
        <el-button type="primary" @click="visible = false">返 回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: null,
        customerSelfNo: null,
        inWarehouseNo: null,
        customerName: null,
        companyRemark: null
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.dataForm.id = row.orderInfo.id
      this.dataForm.customerSelfNo = row.orderInfo.customerSelfNo
      this.dataForm.inWarehouseNo = row.orderInfo.inWarehouseNo
      this.dataForm.customerName = row.orderInfo.customerName
      this.dataForm.companyRemark = row.orderInfo.companyRemark
    },
    confirm () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let data = {
            id: this.dataForm.id,
            inWarehouseNo: this.dataForm.inWarehouseNo,
            customerSelfNo: this.dataForm.customerSelfNo,
            companyRemark: this.dataForm.companyRemark
          }
          this.$http({
            url: this.$http.adornUrl(`/order/updateOrderNumber`),
            method: 'POST',
            data: this.$http.adornData(data)
          }).then(({ data }) => {
            if (data) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error('保存失败')
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
